<template>
  <div :style="`height: ${contentHeight};`" class="pa-4 overflow--y">
    <div v-if="hasRole('billing', 'ROLE_GET_PAGINATED_ORDERS')">
      <div v-if="data.numericalId" class="mb-2">
        <div class="item__label">{{ $t(`${namespace}.invoiceId`) }}</div>
        <div>{{ data.numericalId }}</div>
      </div>

      <div v-if="data.company" class="mb-2">
        <div class="item__label text--capitalize">{{ $t('Common.company') }}</div>
        <div>
          {{ data.company.companyId || '-' }} - {{ data.company.companyName || '-' }}
        </div>
      </div>

      <div v-if="data.totalValue" class="mb-2">
        <div class="item__label">{{ $t('Common.value') }}</div>
        <div>{{ data.totalValue | currencyBRL }}</div>
      </div>

      <div v-if="data.updatedUser" class="mb-2">
        <div class="item__label">{{ $t(`${namespace}.userWhoUpdated`) }}</div>
        <div>{{ data.updatedUser }}</div>
      </div>

      <div v-if="data.updateDateOpt" class="mb-2">
        <div class="item__label">{{ $t(`${namespace}.updateDate`) }}</div>
        <div>{{ data.updateDateOpt | formatDate('DD/MM/YYYY') }}</div>
      </div>

      <div v-if="data.reason" class="mb-2">
        <div class="item__label">{{ $t(`${namespace}.justification`) }}</div>
        <div>{{ data.reason }}</div>
      </div>

      <div v-if="data.bankInformation" class="pt-3">
        <h2 class="drawer__subtitle pb-2">{{ $t(`${namespace}.bankInformation`) }}</h2>
        <div v-if="data.bankInformation.numberOfBank || data.bankInformation.bank" class="mb-2">
          <div class="item__label">{{ $t(`${namespace}.bank`) }}</div>
          <div>{{ data.bankInformation.numberOfBank }} - {{ data.bankInformation.bank }}</div>
        </div>

        <v-layout>
          <v-flex>
            <div v-if="data.bankInformation.branch " class="mb-2">
              <div class="item__label">{{ $t(`${namespace}.branch`) }}</div>
              <div>{{ data.bankInformation.branch }}</div>
            </div>
          </v-flex>

          <v-flex>
            <div v-if="data.bankInformation.bankAccount" class="mb-2">
              <div class="item__label">{{ $t(`${namespace}.bankAccount`) }}</div>
              <div>{{ data.bankInformation.bankAccount }}</div>
            </div>
          </v-flex>

          <v-flex>
            <div v-if="data.bankInformation.digit" class="mb-2">
              <div class="item__label">{{ $t(`${namespace}.digit`) }}</div>
              <div>{{ data.bankInformation.digit }}</div>
            </div>
          </v-flex>
        </v-layout>

        <div v-if="data.bankInformation.receiptMethod" class="mb-2">
          <div class="item__label">{{ $t(`${namespace}.receiptMethod`) }}</div>
          <div>{{ data.bankInformation.receiptMethod }}</div>
        </div>

        <div v-if="data.bankInformation.accountingInSap" class="mb-2">
          <div class="item__label">{{ $t(`${namespace}.accountingInSap`) }}</div>
          <div>{{ data.bankInformation.accountingInSap }}</div>
        </div>
      </div>
    </div>

    <EmptyState
      v-else
      image="employee"
      :imageSize="120"
      class="px-4"
    >
      <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
    </EmptyState>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole, calcContentHeight } from 'utils/functions'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Preview',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    EmptyState
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.approvePayment.preview',
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = `${calcContentHeight()}px`
    },

    handleEditProject () {
      this.$emit('toggleAction', 'edit')
    },

    change (drawer, data) {
      this.$emit('change', {
        drawer: {
          type: drawer.type,
          action: drawer.action
        },
        data: {
          id: data.id,
          name: data.name
        }
      })
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.container__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 800;
}
</style>
